export class MidwayTokenError extends Error {
  constructor() {
    super(`User is not authenticated with Midway`);
  }
}


// WEBPACK FOOTER //
// ./src/errors/midwayError.js